import React from 'react';
import { FadeIn } from './FadeIn';
import { Mail } from 'lucide-react';
export function Contact() {
  return <section className="py-32 px-6 relative overflow-hidden" data-id="element-15">
      {/* Decorative background element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber/5 rounded-full blur-3xl -z-10" data-id="element-16" />

      <div className="max-w-2xl mx-auto text-center" data-id="element-17">
        <FadeIn data-id="element-18">
          <span className="text-sage font-medium tracking-widest uppercase text-sm mb-4 block" data-id="element-19">
            What's Next?
          </span>
          <h2 className="font-playfair text-5xl md:text-6xl text-charcoal mb-8" data-id="element-20">
            Let's Connect
          </h2>

          <p className="text-lg text-charcoal/70 font-light mb-12 leading-relaxed" data-id="element-21">
            I'm looking for paralegal or legal assistant roles as I wrap up the
            UCLA program. If you've got an opening, know someone who does, or
            just want to chat, drop me a line.
          </p>

          <a href="mailto:jacobpalkin@gmail.com" className="inline-flex items-center gap-3 bg-charcoal text-cream px-8 py-4 rounded-full text-lg hover:bg-amber transition-colors duration-300 mb-16" data-id="element-22">
            <Mail size={20} data-id="element-23" />
            Say Hello
          </a>

          <div className="mt-16 pt-8 border-t border-amber/15 max-w-sm mx-auto" data-id="element-24">
            <p className="text-charcoal/50 text-sm font-light italic tracking-wide" data-id="element-25">
              References available upon request.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}